export const inlineScript = {
  mounted(el, binding) {
    const script = document.createElement('script');
    const scriptSrc = binding.value;
    script.src = scriptSrc;
    script.id = el.id;
    el.after(script);
    el.parentElement.removeChild(el);
  },
};
